// extracted by mini-css-extract-plugin
export default {"navigation_title":"styles_navigation_title__kYU1Q"};